import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserSettingsStorage } from '@app/core/storage/user.settings.storage';
import { first } from 'rxjs';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { FirmSelectors } from 'src/app/core/state/firm/firm.selectors';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-firm-system-settings',
  templateUrl: './firm-system-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [getTranslationProvider('FirmSystemSettingsComponent')],
})
export class FirmSystemSettingsComponent extends TranslatableComponent {
  public termsOfAgreementUrl: string;

  constructor() {
    super();

    this.store
      .select(FirmSelectors.selectCountryCode)
      .pipe(first(Boolean))
      .subscribe((countryCode) => {
        this.termsOfAgreementUrl = environment.termsOfAggrementUrl[countryCode] || environment.termsOfAggrementUrl.SE;
      });
  }

  clearStorageAndLogout() {
    new UserSettingsStorage().clearSettings(true);
    window.location.href = environment.loginUrl;
  }
}
